// layout colors
import blackColor from '../../layout/colors/black.color.layout';

const TAG_BACKGROUND_COLOR = blackColor;

export default TAG_BACKGROUND_COLOR;
